var map = {
	"./approval.svg": "./src/assets/icons/svg/approval.svg",
	"./config.svg": "./src/assets/icons/svg/config.svg",
	"./definition.svg": "./src/assets/icons/svg/definition.svg",
	"./dept.svg": "./src/assets/icons/svg/dept.svg",
	"./doing.svg": "./src/assets/icons/svg/doing.svg",
	"./list.svg": "./src/assets/icons/svg/list.svg",
	"./log.svg": "./src/assets/icons/svg/log.svg",
	"./loginUser.svg": "./src/assets/icons/svg/loginUser.svg",
	"./menu.svg": "./src/assets/icons/svg/menu.svg",
	"./model.svg": "./src/assets/icons/svg/model.svg",
	"./pass.svg": "./src/assets/icons/svg/pass.svg",
	"./pedding_approval.svg": "./src/assets/icons/svg/pedding_approval.svg",
	"./role.svg": "./src/assets/icons/svg/role.svg",
	"./success_approval.svg": "./src/assets/icons/svg/success_approval.svg",
	"./system.svg": "./src/assets/icons/svg/system.svg",
	"./todo.svg": "./src/assets/icons/svg/todo.svg",
	"./user.svg": "./src/assets/icons/svg/user.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/svg sync \\.svg$";